import { createFileRoute } from '@tanstack/react-router';
import { AdminCoachConversationsView } from '@/components/admin/AdminCoachConversationsView';

export const Route = createFileRoute('/_authed/admin/coach/')({
  component: CoachConversationsPage,
});

function CoachConversationsPage() {
  return <AdminCoachConversationsView />;
}
